<template>
	<div class="mb-4">
		<v-card class="mb-3"
			color="grey lighten-1"
			justify-center>
			<br>

			<div class="text-xs-center mt-3 mb-5">
				<h2>Podaj dane teleadresowe podmiotu</h2>
			</div>

			<v-container class="text-xs-center mt-3">
				<v-layout align-center justify-center row>
					<v-flex xs3/>
					<v-flex xs6>
						<v-text-field
							browser-autocomplete="email"
							data-vv-name="organizationEmail"
							data-vv-as="E-mail organizacji"
							:error-messages="vErrors.collect('scope3.organizationEmail')"
							label="E-mail organizacji *"
							aria-label="label for organization email"
							for="step-adress-data-component-organization-mail"
							id="step-adress-data-component-organization-mail"
							v-model="stepData.organizationEmail"
							data-vv-validate-on="none"
							v-validate="'required|email'"
							data-vv-scope="scope3"
						></v-text-field>
					</v-flex>
					<v-flex xs3/>
				</v-layout>

				<v-layout align-center justify-center row>
					<v-flex xs3/>
					<v-flex xs6>
						<v-text-field
							browser-autocomplete="url"
							data-vv-name="websiteAddress"
							data-vv-as="Strona internetowa"
							:error-messages="vErrors.collect('scope3.websiteAddress')"
							label="Strona internetowa"
							aria-label="label for website address"
							for="step-adress-data-component-web-site"
							id="step-adress-data-component-web-site"
							v-model="stepData.websiteAddress"
							data-vv-validate-on="none"
							v-validate="{url: {require_protocol: false }}"
							data-vv-scope="scope3"
						></v-text-field>
					</v-flex>
					<v-flex xs3/>
				</v-layout>

				<v-layout align-center justify-center row>
					<v-flex xs3/>
					<v-flex xs6>
						<v-text-field
							browser-autocomplete="tel"
							data-vv-name="phoneNumber"
							data-vv-as="Telefon"
							:error-messages="vErrors.collect('scope3.phoneNumber')"
							label="Telefon *"
							aria-label="label for phone number"
							for="step-adress-data-component-phone"
							id="step-adress-data-component-phone"
							v-model="stepData.phoneNumber"
							v-validate="{required: true, regex: /^([(][0-9 +-]*[)])?[0-9 +-]*$/}"
							data-vv-validate-on="none"
							data-vv-scope="scope3"
						></v-text-field>
					</v-flex>
					<v-flex xs3/>
				</v-layout>
			</v-container>

			<div class="text-xs-center mt-3 mb-3">
				<h2>Adres siedziby</h2>
			</div>

			<v-container class="text-xs-center mt-3">

				<v-layout align-center justify-center row>
					<v-flex xs12 sm12>
						<v-text-field
							browser-autocomplete="off"
							data-vv-name="street"
							data-vv-as="Ulica"
							:error-messages="vErrors.collect('scope3.street')"
							label="Ulica *"
							aria-label="label for street name"
							for="step-adress-data-component-street"
							id="step-adress-data-component-street"
							v-model="stepData.address.street"
							v-validate="'required'"
							data-vv-scope="scope3"
						></v-text-field>
					</v-flex>
					<v-flex sm1/>
					<v-flex xs12 sm4>
						<v-text-field
							browser-autocomplete="off"
							data-vv-name="building"
							data-vv-as="Numer domu"
							:error-messages="vErrors.collect('scope3.building')"
							label="Numer domu *"
							aria-label="label for building number"
							for="step-adress-data-component-address-building"
							id="step-adress-data-component-address-building"
							v-model="stepData.address.building"
							v-validate="'required'"
							data-vv-scope="scope3"
						></v-text-field>
					</v-flex>
					<v-flex sm1/>
					<v-flex xs12 sm4>
						<v-text-field
							browser-autocomplete="off"
							label="Numer lokalu"
							aria-label="label for apartment number"
							for="step-adress-data-component-address-apartment"
							id="step-adress-data-component-address-apartment"
							v-model="stepData.address.apartment"
						></v-text-field>
					</v-flex>
				</v-layout>

				<div>
					<v-layout align-center justify-center row>
						<v-flex xs12 sm4>
							<v-text-field
								browser-autocomplete="off"
								data-vv-name="postalCode"
								data-vv-as="Kod pocztowy"
								:error-messages="vErrors.collect('scope3.postalCode')"
								label="Kod pocztowy *"
								aria-label="label for postal code"
								for="step-adress-data-component-postal-code"
								id="step-adress-data-component-postal-code"
								v-model="stepData.address.postalCode"
								data-vv-validate-on="none"
								v-validate="{ required: true, regex: /^([0-9]{2}-[0-9]{3})$/}"
								return-masked-value
								:mask="'##-###'"
								data-vv-scope="scope3"
							></v-text-field>
						</v-flex>
						<v-flex sm1/>
						<v-flex xs12 sm8>
							<v-text-field
								browser-autocomplete="off"
								data-vv-name="city"
								data-vv-as="Miejscowość"
								:error-messages="vErrors.collect('scope3.city')"
								label="Miejscowość *"
								aria-label="label for address city"
								for="step-adress-data-component-city"
								id="step-adress-data-component-city"
								v-model="stepData.address.city"
								v-validate="'required'"
								data-vv-scope="scope3"
							></v-text-field>
						</v-flex>
						<v-flex sm1/>
						<v-flex xs12 sm6>
							<v-select
								browser-autocomplete="off"
								data-vv-name="province"
								data-vv-as="Województwo"
								:error-messages="vErrors.collect('scope3.province')"
								v-model="stepData.province"
								:items="provinceItems"
								label="Województwo *"
								aria-label="label for province"
								for="step-adress-data-component-province"
								id="step-adress-data-component-province"
								v-validate="'required'"
								data-vv-scope="scope3"
							></v-select>
						</v-flex>
					</v-layout>
				</div>
			</v-container>

			<div>
				<v-btn
					@click="handleCorrespondenceChosen"
					color="blue"
					class="mb-3">
					Adres korespondencyjny&nbsp;
					<v-icon v-if="correspondenceAddress">indeterminate_check_box</v-icon>
					<v-icon v-else color="white">question_answer</v-icon>
				</v-btn>
			</div>

			<div>
				<v-expand-transition>
					<div v-if="correspondenceAddress">
						<div class="text-xs-center mt-3">
							<h2>Adres korespondencyjny</h2>
						</div>

						<v-container class="text-xs-center mt-4">

							<v-layout align-center justify-center row>
								<v-flex xs12 sm12>
									<v-text-field
										browser-autocomplete="off"
										data-vv-name="correspondenceStreet"
										data-vv-as="Ulica"
										:error-messages="vErrors.collect('scope3.correspondenceStreet')"
										label="Ulica *"
										aria-label="label for correspondence street name"
										for="step-adress-data-component-street"
										id="step-adress-data-component-street"
										v-model="stepData.correspondenceAddress.street"
										v-validate="'required'"
										data-vv-scope="scope3"
									></v-text-field>
								</v-flex>
								<v-flex sm1/>
								<v-flex xs12 sm4>
									<v-text-field
										browser-autocomplete="off"
										data-vv-name="correspondenceBuilding"
										data-vv-as="Numer domu"
										:error-messages="vErrors.collect('scope3.correspondenceBuilding')"
										label="Numer domu *"
										aria-label="label for correspondence building number"
										for="step-adress-data-component-correspondence-building"
										id="step-adress-data-component-correspondence-building"
										v-model="stepData.correspondenceAddress.building"
										v-validate="'required'"
										data-vv-scope="scope3"
									></v-text-field>
								</v-flex>
								<v-flex sm1/>
								<v-flex xs12 sm4>
									<v-text-field
										browser-autocomplete="off"
										label="Numer lokalu"
										aria-label="label for correspondence apartment number"
										for="step-adress-data-component-correspondence-local"
										id="step-adress-data-component-correspondence-local"
										v-model="stepData.correspondenceAddress.apartment"
									></v-text-field>
								</v-flex>
							</v-layout>

							<v-layout align-space-between justify-space-around>
								<v-flex xs12 sm4>
									<v-text-field
										browser-autocomplete="off"
										data-vv-name="correspondencePostalCode"
										data-vv-as="Kod pocztowy"
										:error-messages="vErrors.collect('scope3.correspondencePostalCode')"
										label="Kod pocztowy *"
										aria-label="label for correspondence postal code"
										for="step-adress-data-component-postal-code*"
										id="step-adress-data-component-postal-code*"
										v-model="stepData.correspondenceAddress.postalCode"
										v-validate="{ required: true, regex: /^([0-9]{2}-[0-9]{3})$/}"
										return-masked-value
										:mask="'##-###'"
										data-vv-validate-on="none"
										data-vv-scope="scope3"
									></v-text-field>
								</v-flex>
								<v-flex sm1/>
								<v-flex xs12 sm8>
									<v-text-field
										browser-autocomplete="off"
										data-vv-name="correspondenceCity"
										data-vv-as="Miejscowość"
										:error-messages="vErrors.collect('scope3.correspondenceCity')"
										label="Miejscowość *"
										aria-label="label for correspondence address city"
										for="step-adress-data-component-city*"
										id="step-adress-data-component-city*"
										v-model="stepData.correspondenceAddress.city"
										v-validate="'required'"
										data-vv-scope="scope3"
									></v-text-field>
								</v-flex>
								<v-flex sm1/>
								<v-flex xs12 sm6>
									<v-select
										browser-autocomplete="off"
										data-vv-name="correspondenceProvince"
										data-vv-as="Województwo"
										:error-messages="vErrors.collect('scope3.correspondenceProvince')"
										v-model="stepData.correspondenceProvince"
										:items="provinceItems"
										label="Województwo *"
										aria-label="label for correspondence province"
										for="step-adress-data-component-province*"
										id="step-adress-data-component-province*"
										v-validate="'required'"
										data-vv-scope="scope3"
									></v-select>
								</v-flex>

							</v-layout>

						</v-container>
					</div>
				</v-expand-transition>
			</div>
		</v-card>
		<v-btn
			@click="$emit('step', 2)"
			color="blue">Wstecz
		</v-btn>
		<v-btn
			color="primary"
			@click="$emit('step', 4, 'scope3')">
			Dalej
		</v-btn>
	</div>
</template>

<script>

	export default {
		name: "StepAddressDataComponent",
		inject: ["parentValidator"],

		methods: {
			handleCorrespondenceChosen() {
				this.correspondenceAddress = !this.correspondenceAddress;

				if (this.correspondenceAddress === false) {
					this.stepData.correspondenceAddress.city = "";
					this.stepData.correspondenceAddress.apartment = "";
					this.stepData.correspondenceAddress.building = "";
					this.stepData.correspondenceAddress.street = "";
					this.stepData.correspondenceAddress.postalCode = "";
					this.stepData.correspondenceProvince = "";
				}
			},
		},

		created() {
			this.$validator = this.parentValidator;
		},

		data() {
			return {
				correspondenceAddress: false,

				provinceItems: [
					"dolnośląskie",
					"kujawsko-pomorskie",
					"lubelskie",
					"lubuskie",
					"łódzkie",
					"małopolskie",
					"mazowieckie",
					"opolskie",
					"podkarpackie",
					"podlaskie",
					"pomorskie",
					"śląskie",
					"świętokrzyskie",
					"wamińsko-mazurskie",
					"wielkopolskie",
					"zachodniopomorskie",
				],
			};
		},

		props: {
			stepData: Object,
		},
	};
</script>

<style scoped>
	.theme--dark.v-btn:not(.v-btn--icon):not(.v-btn--flat) {
		background-color: #212121 !important;
	}

	.v-icon {
		color: #fff !important;
	}
</style>
